module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgBxZI9TsNAEIXfGEtGVOEELB1slSMsnICcwKJAcmjgCOEEobMlCrhBcgJYbpBqhah8BFcIIfCwg7JgB0eRq7xmPeN93779AbYtCh/HZnxGhNmG+aV7yg+bjfiPxIMfHvN5l5MBQ0SpNpf3QP3sbPHQAgSFH6vSJpMhhSxENNWnmXKPxSRCTzmbj3xQizo66EywSfpkzLKfT/BI6t4J5IzeONl/tfm8BWBQJaMy14NOH2rpV3JGpb2tQv8XkCCxMmEv+pgemUw1zb72N7BzBab5KpiahTYXQ6Z45pvqfwJY9vFfbFGuBYQt7OJ9GLUgXwtn7xboEC0jKm8w6KHaJ5I08ZIy8Y8j7QPwt3ED8W1d33xEWUnqoWV/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-active-2.png
// module id = 2605
// module chunks = 0